/**
 * "TAU_RISE=30s (time constant for CPU rise) because …" → its parts, when the
 * sentence leads with a constant and a number, or with true or false for an
 * on/off signal ("FAN_RUNNING = false (…)"). Anything else comes back as the
 * reason alone, and the box shows it whole.
 */
export function parseAssumed(sentence: string): { name: string; value: string; what: string; why: string } {
  const text = sentence.replace(/^\s*assumed\b:?\s*/i, '').trim();
  const m = /^([A-Za-z_][\w.]*)\s*=\s*((?:true|false)\b|[-+]?\d[\d.,]*\s*(?:[A-Za-z%µ°/]+)?)\s*(?:\(([^)]*)\))?\s*[,;:—–-]?\s*(.*)$/i.exec(
    text,
  );
  if (!m) return { name: '', value: '', what: '', why: text };
  const why = m[4].trim();
  return { name: m[1], value: m[2].trim(), what: (m[3] ?? '').trim(), why: why ? why.charAt(0).toUpperCase() + why.slice(1) : '' };
}
